import "bootstrap/dist/css/bootstrap.min.css";

import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App/App";
import { AuthProvider } from "./contexts/auth_provider";
import { UserProvider } from "./contexts/user_provider";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <AuthProvider>
            <UserProvider>
                <App />
            </UserProvider>
        </AuthProvider>
    </React.StrictMode>,
);
